export default __webpack_public_path__ + "c38d2aafccc5210ab4b0bc38a5a45db4.ico";